import { render, staticRenderFns } from "./SingleSelectHospital.vue?vue&type=template&id=660feae8&scoped=true&"
import script from "./SingleSelectHospital.vue?vue&type=script&lang=js&"
export * from "./SingleSelectHospital.vue?vue&type=script&lang=js&"
import style0 from "./SingleSelectHospital.vue?vue&type=style&index=0&id=660feae8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660feae8",
  null
  
)

export default component.exports